import {PrintOnDemandFileType} from '../../dialogs/print-on-demand-dialog/print-on-demand-dialog.component';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {Component, Inject} from '@angular/core';
import {PrintOnDemandService} from '../../api/services/print-on-demand.service';
import {finalize} from 'rxjs/operators';

export class PrintOnDemandData {
  public fileType: PrintOnDemandFileType;
  public pages: string[];
  public interactId?: number;
  public embeddedTypeId?: number;
  public bookmarkId?: number;
  public bookmarkJson?: string;
}

@Component({
  selector: 'pod-status-snackbar',
  templateUrl: './pod-status-snackbar.component.html'
})
export class PodStatusSnackbarComponent {
  public status: string;
  public progress: number;

  public didComplete = false;
  public hasError = false;
  public errorMessage: string;

  public checkTimer: any = null;
  private checkingStatus = false;

  public jobId = -1;

  public downloadUrl: string;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: PrintOnDemandData,
    public snackBarRef: MatSnackBarRef<PodStatusSnackbarComponent>,
    public printOnDemandService: PrintOnDemandService
    ) {

    this.status = 'Requesting Export...';
    this.progress = 0;
    this.didComplete = false;
    this.hasError = false;
    this.errorMessage = '';

    this.printOnDemandService.printOnDemandPrintOnDemand({
      fileType: data.fileType,
      pages: data.pages,
      interactId: data.interactId,
      reportEmbeddedTypeId: data.embeddedTypeId,
      bookmarkId: data.bookmarkId,
      bookmarkJson: data.bookmarkJson
    }).subscribe(result => {
      this.jobId = result;
      this.checkTimer = setInterval(() => {
        this.updateStatus();
      }, 2000);
    }, error => {
      this.didComplete = true;
      this.hasError = true;
      this.errorMessage = 'Failed To Submit Print Job';
    });
  }

  private updateStatus() {
    // Wait for the previous status request to complete before asking again.
    if (this.checkingStatus) {
      return;
    }

    this.checkingStatus = true;
    this.printOnDemandService.printOnDemandGetPrintOnDemandStatus(this.jobId).pipe(
      finalize(() => this.checkingStatus = false)
    ).subscribe(result => {
      this.status = result.status;
      this.progress = result.progress;
      this.didComplete = result.didComplete;
      this.hasError = result.hasError;
      this.errorMessage = result.errorMessage;

      if (this.didComplete) {
        this.downloadUrl = result.downloadUrl;
        clearInterval(this.checkTimer);
      }
    });
  }

  public close() {
    this.snackBarRef.dismiss();
    return false;
  }

  downloadReport() {
    window.open(this.downloadUrl, '_blank');

    return false;
  }
}
